/* eslint-env browser */
import { firebaseConfig } from '../src/helpers/firebaseConfig';

export const registerServiceWorker = () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  const run = () => {
    try {
      // 1. Actively unregister any legacy expo-service-worker or rogue caching workers
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (var i = 0; i < registrations.length; i++) {
          var reg = registrations[i];
          if (
            reg.active &&
            reg.active.scriptURL &&
            (reg.active.scriptURL.indexOf('expo-service-worker') !== -1 ||
             reg.active.scriptURL.indexOf('service-worker.js') !== -1)
          ) {
            reg.unregister().then(function (unregistered) {
              if (unregistered) {
                console.log('[SW] Successfully removed legacy caching service worker');
              }
            });
          }
        }
      }).catch(function (e) {
        console.warn('[SW] Error checking service worker registrations:', e);
      });

      // 2. Register Firebase Messaging Service Worker (push notifications only, no HTML caching)
      navigator.serviceWorker
        .register('/firebase-messaging-sw.js', {
          scope: '/',
          updateViaCache: 'none',
        })
        .then(function (registration) {
          if (registration && typeof registration.update === 'function') {
            registration.update().catch(function () {});
          }
          return registration.scope;
        })
        .catch(function (err) {
          console.warn('[SW] Failed to register firebase-messaging-sw:', err);
        });

      // 3. Register OneSignal SDK Worker if applicable
      navigator.serviceWorker
        .register('/OneSignalSDKWorker.js', { scope: '/', updateViaCache: 'none' })
        .catch(function () {});
    } catch (e) {
      console.warn('[SW] Exception while managing service workers:', e);
    }
  };

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    run();
  } else {
    window.addEventListener('load', run);
  }
};
